import { render, staticRenderFns } from "./LgOrderCancellation.vue?vue&type=template&id=ddda256e&scoped=true&"
import script from "./LgOrderCancellation.vue?vue&type=script&lang=js&"
export * from "./LgOrderCancellation.vue?vue&type=script&lang=js&"
import style0 from "./LgOrderCancellation.vue?vue&type=style&index=0&id=ddda256e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda256e",
  null
  
)

export default component.exports